import React from 'react';
import OverlayLoading from '../../../../../../Components/OverlayLoading';
import ScrollContainer from '../../../../../Base/Components/ScrollContainer';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../../../../../../Components/Loading';
import DataTable from '../../../../../Base/Components/DataTable/DataTable';
import {
	MedicalProcedureImport,
	MedicalProceduresImportTable,
	MedicalProceduresImportDefaultColumns,
} from '../../../../Consts/MedicalProceduresImportDefaultColumns.const';
import styles from './ManagerInsuranceCompaniesImportTable.module.scss';

const WRAPPER_ID = 'medicalProceduresImport';

interface Props {
	data: MedicalProcedureImport[];
	isLoading: boolean;
	onRefresh: () => void;
	onLoadMore: () => void;
	hasMoreData: boolean;
	selectedIds: Set<string>;
	toggleSelectedId: (id: string, value: boolean) => void;
}

const ManagerInsuranceCompaniesImportTable = ({
	data,
	isLoading,
	onRefresh,
	onLoadMore,
	hasMoreData,
	selectedIds,
	toggleSelectedId,
}: Props) => {
	const table: MedicalProceduresImportTable = {
		selectedIds,
		toggleSelectedId,
	};

	return (
		<>
			{isLoading && <OverlayLoading />}
			<div className={styles.wrapper}>
				<ScrollContainer wrapperId={WRAPPER_ID}>
					<InfiniteScroll
						dataLength={data.length}
						refreshFunction={onRefresh}
						next={onLoadMore}
						hasMore={hasMoreData}
						loader={<Loading />}
						scrollableTarget={WRAPPER_ID}>
						<DataTable<MedicalProcedureImport, MedicalProceduresImportTable>
							data={data}
							table={table}
							columns={MedicalProceduresImportDefaultColumns}
						/>
					</InfiniteScroll>
				</ScrollContainer>
			</div>
		</>
	);
};

export default ManagerInsuranceCompaniesImportTable;
